import React, { StrictMode } from "react";
import { ApolloProvider } from "@apollo/client";
import { client } from "./apollo/client";
import { BrowserRouter } from "react-router-dom";
import ChatContainer from "./components/chat/ChatContainer";

export const ChatApp = ({ mainElementSelector }) => (
  <StrictMode>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <ChatContainer chatContainerSelector={mainElementSelector} />
      </BrowserRouter>
    </ApolloProvider>
  </StrictMode>
);
